import ChevronLeftIcon from '@heroicons/react/24/outline/ChevronLeftIcon';
import { Button } from 'atp-react-ui';

import { ROUTES } from '@/_navigation/routes';
import { useDataContext } from '@/_provider';
import DarkLogo from '@/_static/assets/atp_dark_icon.svg?react';
import LightLogo from '@/_static/assets/atp_white_icon.svg?react';

export function Header({ lightLogo, hideBackButton = false }) {
  const { currentObj, currentPage, nav } = useDataContext();

  const handleShowBackButton = () => {
    return currentPage !== ROUTES.QUALIFY.link;
  };

  const showBackButton = handleShowBackButton();
  const backLabel = currentObj?.backLabel;

  return (
    <header className="flex h-16 justify-between">
      <div>
        {showBackButton &&
          !currentObj?.hideBackButton &&
          !hideBackButton &&
          (backLabel ? (
            <Button
              as="link"
              theme="primary"
              className="hover:bg-accent-light/10 focus:ring-0 disabled:border-primary-light disabled:bg-primary-light disabled:text-primary-medium"
              onClick={() => nav(-1)}
              iconLeft={ChevronLeftIcon}
            >
              {backLabel !== null && <div>{backLabel}</div>}
            </Button>
          ) : (
            <Button
              as="link"
              theme="primary"
              className="hover:bg-accent-light/10 focus:ring-0 disabled:border-primary-light disabled:bg-primary-light disabled:text-primary-medium"
              onClick={() => nav(-1)}
              iconLeft={ChevronLeftIcon}
            />
          ))}
      </div>

      <div>
        {currentObj?.lightLogo || lightLogo ? (
          <LightLogo className="w-7 md:w-10" />
        ) : (
          <DarkLogo className="w-7 md:w-10" />
        )}
      </div>
    </header>
  );
}
